import { useState } from "react";

import { HeroNoticias } from "../../components/noticias/hero";
import { NoticiasPage } from "../../components/noticias/Noticias";
import { useNoticiasPublicas } from "../../hooks/useNoticias";

const categorias = [
    {
        label: "Todas",
        value: "Todas",
    },
    {
        label: "Comunicados",
        value: "comunicado",
    },
    {
        label: "Eventos",
        value: "eventos",
    },
    {
        label: "Académico",
        value: "academico",
    },
    {
        label: "Matrículas",
        value: "matriculas",
    },
    {
        label: "Deportes",
        value: "deporte",
    },
    {
        label: "Talleres",
        value: "talleres",
    },
];

export const NoticiasPages = () => {

    const [buscar, setBuscar] = useState("");

    const [categoria, setCategoria] =
        useState("Todas");

    const [page, setPage] = useState(1);


    /*
    |--------------------------------------------------------------------------
    | NOTICIAS DESDE API
    |--------------------------------------------------------------------------
    */

    const {
        noticias,
        loading,
        error,
    } = useNoticiasPublicas();


    return (

        <>

            <HeroNoticias
                buscar={buscar}
                setBuscar={setBuscar}
            />


            <NoticiasPage
                noticias={noticias}
                loading={loading}
                error={error}
                categorias={categorias}
                buscar={buscar}
                categoria={categoria}
                setCategoria={setCategoria}
                page={page}
                setPage={setPage}
            />

        </>

    );

};